module.exports = __webpack_public_path__ + "src/assets/img/logo.4a398b25.png";